import translations from "./translation";
import managecookies from "./managecookies";


const useLang = (code) => {
    // Get the selected language from local storage
    const selectedLang = localStorage.getItem('selectedLang') || 'he'; // Default to 'en' if not set
    const langObj = translations[selectedLang] || translations['he'];
    // Return the word in the selected language
    if (!langObj) return code;
    return langObj[code] || langObj['DEFAULT_MSG'] || code;
};

function isLog() {
    return true
}

function saveSession(key, data) {
    // Parse data if it is a string
    let parsedData;
    if (typeof data === 'string') {
        try {
            parsedData = JSON.parse(data);
        } catch (error) {
            console.error("Data is not a valid JSON string:", data);
            return;
        }
    } else {
        parsedData = data;
    }

    // Ensure data is an object or an array
    if (typeof parsedData === 'object' && parsedData !== null) {
        const sessionData = {
            data: parsedData,
            timestamp: new Date().getTime() // Save the current timestamp
        };
        localStorage.setItem(key, JSON.stringify(sessionData));
    } else {
        console.error("Data is not an object or array:", parsedData);
    }
}


function _getSession(key) {
    return JSON.parse(localStorage.getItem(key))
}

function isSessionValid(key) {
    const sessionData = _getSession(key);
    if (sessionData) {
        const savedTime = sessionData.timestamp;
        if (savedTime) {
            const currentTime = new Date().getTime();
            const oneHour = 1000 * 60 * 60; // Time in milliseconds
            if (currentTime - savedTime < oneHour) {
                return sessionData.data; // Session is valid
            }
        }
    }
    return false; // Session is not valid
}

function getToken() {
    return managecookies.getCookieVal('authToken')
}

function getBusToken() {
    return managecookies.getCookieVal('busiToken')
}

const getLangCode = (key) => {
    const selectedLang = localStorage.getItem('selectedLang') || 'he'; // Default to 'en' if not set
    // Return the word in the selected language
    return translations[selectedLang][key.toUpperCase()] || translations[selectedLang]['DEFAULT_MSG'];
}

const checkIfIdExists = (obj, key, arrayToCheck) => {
    return arrayToCheck.some(item => item.ID === obj[key]);
};
function clearSession(key) {
    if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key);
    }
}

export default {
    getToken,
    getLangCode,
    saveSession,
    getBusToken,
    isSessionValid,
    clearSession,
    useLang,
    isLog,
    checkIfIdExists
}